import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import DialogNewRecentDescription from './DialogNewRecentDescription/DialogNewRecentDescription';

export default function NewRecentDescription() {
    const [showInfo, setShowInfo] = React.useState<boolean>(false);

    const handleClick = () => {
        setShowInfo(!showInfo);
    };

    return (
        <>
            <Tooltip title="New Recent Description" disableInteractive>
                <IconButton aria-label="Filter Description" onClick={handleClick} size="small">
                    <HelpOutlineIcon />
                </IconButton>
            </Tooltip>
            {showInfo && (
                <DialogNewRecentDescription isOpen={showInfo} onConfirmHandler={handleClick} />
            )}
        </>
    );
}
